import ApiService from "@/core/services/api.service";
// action types
export const FIND_COMPANY = "findCompany";
export const UPDATE_COMPANY = "updateCompany";
export const LIST_COMPANY_DATA = "listCompanyData";

export default {
  state: {
    path: "company"
  },
  getters: {},
  actions: {
    [FIND_COMPANY](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`, null);
    },
    [UPDATE_COMPANY](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [LIST_COMPANY_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    }
  },
  mutations: {}
};
